module.exports = __webpack_public_path__ + "img/au_express.bbcff123.jpg";